import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
// import Vuetify from 'vuetify'
import App from './App.vue'
import VueAxios from 'vue-axios'

// Plugins
// import GlobalComponents from './gloablComponents'
// import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import VModal from 'vue-js-modal'
import 'chart.js'
import 'hchs-vue-charts'
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
// router setup
import routes from './routes/routes'
// filters
import DateFilter from './filtros/fecha'
import DateFilterC from './filtros/fechaCompleta'
import DiasFaltantes from './filtros/diasFaltantes'
// idle-vue
// import IdleVue from 'idle-vue'


// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'
import 'sweetalert2/src/sweetalert2.scss'
import sidebarLinks from './sidebarLinks'
import sidebarLinksAdmi from './sidebarLlinksAdmi'

// apis
import axios from 'axios'

import 'vue-loaders/dist/vue-loaders.css'
import VueLoaders from 'vue-loaders'

Vue.component('loader', VueLoaders.component)
Vue.use(Loading)


Vue.use(VueAxios, axios)
    // plugin setup
Vue.use(VueRouter)
// Vue.use(GlobalDirectives)
// Vue.use(Vuetify)
// Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, { sidebarLinks: sidebarLinks }, { sidebarLinksAdmi: sidebarLinksAdmi })
Vue.use(VeeValidate)
Vue.use(window.VueCharts)
locale.use(lang)
Vue.use(VModal, { dialog: true })
Vue.filter('date', DateFilter)
Vue.filter('dateC', DateFilterC)
Vue.filter('diasFaltantes', DiasFaltantes)
    // configure router
const router = new VueRouter({
    // mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'active'
})


// const eventsHub = new Vue()
// Vue.use(IdleVue, {
//   eventEmitter: eventsHub,
//   idleTime: 5000
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
})



// WEBPACK FOOTER //
// ./src/main.js